import { restPost } from '~/src/dash/api/rest';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';

export async function logUiError(body: { [key: string]: any }): Promise<any> {
  const reqUrl = getApiDomain() + '/v1/ui_error';
  try {
    await restPost<any>(reqUrl, body);
    return;
  } catch (err) {
    throw err;
  }
}

export async function logUiErrorStaging(body: { [key: string]: any }): Promise<any> {
  const reqUrl = getApiDomain() + '/v1/ui_error?staging';
  try {
    await restPost<any>(reqUrl, body);
    return;
  } catch (err) {
    throw err;
  }
}
